<ion-content class="ion-no-padding">
  <form [formGroup]="taskForm" class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue"><span *ngIf="!editTaskId">Create New</span><span *ngIf="editTaskId">Edit</span> Task <span *ngIf="editTaskId">({{editTaskId}})</span></ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          
          <ion-button *ngIf="!editTaskId" class="filled-blue-btn" type="submit" (click)="onSubmit(true)">Save & New</ion-button>
          <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit(false)">Save</ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>

      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Task Details</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal toggle-visibility" *ngIf="taskForm">
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Subject*</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('subject')?.invalid && taskForm.get('subject')?.touched }">
                <app-live-search [allSearchResults]="taskSubject" [placeHolder]="'Ex: Meeting'" formControlName="subject" [maxLength]="100"></app-live-search>
              </div>
            </div>          
          </div>
          
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Related To</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('relatedTo')?.invalid && taskForm.get('relatedTo')?.touched }">
                <app-relatedto-data-input [selectedType]="'Lead'" [searchOnlyLeads]="true" formControlName="relatedTo"></app-relatedto-data-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Due Date*</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('dueDate')?.invalid && taskForm.get('dueDate')?.touched }">
                <app-date-picker [minDate]="todayDate" formControlName="dueDate"></app-date-picker>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Time*</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('dueTime')?.invalid && taskForm.get('dueTime')?.touched }">
                <app-time-picker formControlName="dueTime"></app-time-picker>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-container">
              <label for="" class="label">Assign Ownership*</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('assignOwner')?.invalid && taskForm.get('assignOwner')?.touched }">
                <app-assigning-users-input formControlName="assignOwner" (emitUserDetails)="assignSelectedUser($event)"></app-assigning-users-input>
              </div>
            </div>          
          </div>
        </div>
        
        <div class="row">
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Status</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('status')?.invalid && taskForm.get('status')?.touched }">
                <select class="input" formControlName="status">
                  <option value="" hidden>-- select status --</option>
                  <option *ngFor="let item of taskStatus" [value]="item.name">{{item.name}}</option>
                </select>
              </div>
            </div>          
          </div>
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Priority*</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('priority')?.invalid && taskForm.get('priority')?.touched }">
                <select class="input" formControlName="priority">
                  <option value="" hidden>-- select priority --</option>
                  <option *ngFor="let item of taskPriority" [value]="item.name">{{item.name}}</option>
                </select>
              </div>
            </div>          
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Reminder</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('reminder')?.invalid && taskForm.get('reminder')?.touched }">
                <app-reminder-input  formControlName="reminder"></app-reminder-input>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Description*</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('description')?.invalid && taskForm.get('description')?.touched }">
                <textarea name="" class="input input-textarea" id="" formControlName="description" placeholder="Write task description" [appMaxLength]="500"></textarea>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Notes</label>
              <div [ngClass]="{ 'invalid-input': taskForm.get('note')?.invalid && taskForm.get('note')?.touched }">
                <textarea name="" class="input input-textarea" id="" formControlName="note" placeholder="Write notes" [appMaxLength]="350"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ion-content>
